import React from 'react';

import styles from './Count.module.scss';

interface CountProps {
  count: number;
}

export const Count = ({ count }: CountProps) => {
  if (count < 0) {
    return null;
  }

  return (
    <div className={styles.moreInsights}>
      <span
        className={styles.count}
        aria-label={`${count} more items`}
      >{`+ ${count}`}</span>
    </div>
  );
};
